import { UPDATEOBJECTIVESTATUS_SUCCESS, UPDATEOBJECTIVESTATUS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const updateObjectiveStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEOBJECTIVESTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEOBJECTIVESTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateObjectiveStatusReducer;
